export default {"src":"/_next/static/image/public/images/flags/flag_1264.3888f178b23e3c8f80c8e16d8961394e.svg","height":16,"width":24};